module.exports = __webpack_public_path__ + "img/GOO.9261c705.svg";